/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
type RawAxiosRequestConfig = AxiosRequestConfig;
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessControlTokenRequest
 */
export interface AccessControlTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessControlTokenRequest
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessControlTokenRequest
     */
    'cardNo'?: string;
}
/**
 * 
 * @export
 * @interface AccessControlTokenResponse
 */
export interface AccessControlTokenResponse {
    /**
     * 
     * @type {number}
     * @memberof AccessControlTokenResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccessControlTokenResponse
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessControlTokenResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessControlTokenResponse
     */
    'cardNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessControlTokenResponse
     */
    'regDate'?: string;
}
/**
 * 
 * @export
 * @interface AccessControlTokenUpdateRequest
 */
export interface AccessControlTokenUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessControlTokenUpdateRequest
     */
    'fullName'?: string;
}
/**
 * 
 * @export
 * @interface AcsEventResponse
 */
export interface AcsEventResponse {
    /**
     * 
     * @type {number}
     * @memberof AcsEventResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AcsEventResponse
     */
    'eventTime': string;
    /**
     * 
     * @type {string}
     * @memberof AcsEventResponse
     */
    'cardNo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcsEventResponse
     */
    'tokenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcsEventResponse
     */
    'eventType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcsEventResponse
     */
    'doorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcsEventResponse
     */
    'controlName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AcsEventResponse
     */
    'ownerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AcsEventResponse
     */
    'ownerName'?: string | null;
}
/**
 * 
 * @export
 * @interface AcsEventsPageResponse
 */
export interface AcsEventsPageResponse {
    /**
     * 
     * @type {Array<AcsEventResponse>}
     * @memberof AcsEventsPageResponse
     */
    'items': Array<AcsEventResponse>;
    /**
     * 
     * @type {number}
     * @memberof AcsEventsPageResponse
     */
    'newestEventId': number | null;
    /**
     * 
     * @type {number}
     * @memberof AcsEventsPageResponse
     */
    'oldestEventId': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AcsEventsPageResponse
     */
    'hasMoreOlder': boolean;
}
/**
 * 
 * @export
 * @interface AdminRequest
 */
export interface AdminRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequest
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface AdminResponse
 */
export interface AdminResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminResponse
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResponse
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResponse
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface BuildingRequest
 */
export interface BuildingRequest {
    /**
     * 
     * @type {string}
     * @memberof BuildingRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuildingRequest
     */
    'address'?: string;
    /**
     * 
     * @type {number}
     * @memberof BuildingRequest
     */
    'cityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingRequest
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingRequest
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface BuildingResponse
 */
export interface BuildingResponse {
    /**
     * 
     * @type {number}
     * @memberof BuildingResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuildingResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuildingResponse
     */
    'address'?: string;
    /**
     * 
     * @type {number}
     * @memberof BuildingResponse
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingResponse
     */
    'latitude'?: number;
    /**
     * 
     * @type {CityResponse}
     * @memberof BuildingResponse
     */
    'city'?: CityResponse;
}
/**
 * 
 * @export
 * @interface BuildingStatistic
 */
export interface BuildingStatistic {
    /**
     * 
     * @type {number}
     * @memberof BuildingStatistic
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuildingStatistic
     */
    'name'?: string;
    /**
     * 
     * @type {Array<BuildingStatisticBuilding>}
     * @memberof BuildingStatistic
     */
    'buildingStatisticBuildings'?: Array<BuildingStatisticBuilding>;
}
/**
 * 
 * @export
 * @interface BuildingStatisticBuilding
 */
export interface BuildingStatisticBuilding {
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticBuilding
     */
    'id'?: number;
    /**
     * 
     * @type {Array<BuildingStatisticFloor>}
     * @memberof BuildingStatisticBuilding
     */
    'buildingStatisticFloors'?: Array<BuildingStatisticFloor>;
    /**
     * 
     * @type {string}
     * @memberof BuildingStatisticBuilding
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticBuilding
     */
    'occupiedTables'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticBuilding
     */
    'notOccupiedTables'?: number;
}
/**
 * 
 * @export
 * @interface BuildingStatisticFloor
 */
export interface BuildingStatisticFloor {
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticFloor
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuildingStatisticFloor
     */
    'name'?: string;
    /**
     * 
     * @type {Array<BuildingStatisticRoom>}
     * @memberof BuildingStatisticFloor
     */
    'buildingStatisticOffices'?: Array<BuildingStatisticRoom>;
    /**
     * 
     * @type {Array<BuildingStatisticRoom>}
     * @memberof BuildingStatisticFloor
     */
    'buildingStatisticConfs'?: Array<BuildingStatisticRoom>;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticFloor
     */
    'occupiedTables'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticFloor
     */
    'notOccupiedTables'?: number;
}
/**
 * 
 * @export
 * @interface BuildingStatisticRoom
 */
export interface BuildingStatisticRoom {
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticRoom
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuildingStatisticRoom
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticRoom
     */
    'totalTables'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticRoom
     */
    'availableTables'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticRoom
     */
    'occupiedTables'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticRoom
     */
    'reservedTables'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingStatisticRoom
     */
    'occupiedByInternTables'?: number;
}
/**
 * 
 * @export
 * @interface BuildingUpdateRequest
 */
export interface BuildingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof BuildingUpdateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuildingUpdateRequest
     */
    'address'?: string;
    /**
     * 
     * @type {number}
     * @memberof BuildingUpdateRequest
     */
    'cityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingUpdateRequest
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingUpdateRequest
     */
    'latitude'?: number;
    /**
     * 
     * @type {Array<FloorUpdateInBuildingRequest>}
     * @memberof BuildingUpdateRequest
     */
    'floorList'?: Array<FloorUpdateInBuildingRequest>;
}
/**
 * 
 * @export
 * @interface BuildingWithFloorInfoResponse
 */
export interface BuildingWithFloorInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof BuildingWithFloorInfoResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuildingWithFloorInfoResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuildingWithFloorInfoResponse
     */
    'address'?: string;
    /**
     * 
     * @type {number}
     * @memberof BuildingWithFloorInfoResponse
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingWithFloorInfoResponse
     */
    'latitude'?: number;
    /**
     * 
     * @type {CityResponse}
     * @memberof BuildingWithFloorInfoResponse
     */
    'city'?: CityResponse;
    /**
     * 
     * @type {Array<FloorResponse>}
     * @memberof BuildingWithFloorInfoResponse
     */
    'floorList'?: Array<FloorResponse>;
}
/**
 * 
 * @export
 * @interface CityRequest
 */
export interface CityRequest {
    /**
     * 
     * @type {string}
     * @memberof CityRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CityRequest
     */
    'countryId'?: number;
}
/**
 * 
 * @export
 * @interface CityResponse
 */
export interface CityResponse {
    /**
     * 
     * @type {number}
     * @memberof CityResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CityResponse
     */
    'name'?: string;
    /**
     * 
     * @type {CountryResponse}
     * @memberof CityResponse
     */
    'country'?: CountryResponse;
}
/**
 * 
 * @export
 * @interface CompanyRequest
 */
export interface CompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CompanyResponse
 */
export interface CompanyResponse {
    /**
     * 
     * @type {number}
     * @memberof CompanyResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CompanyStatistic
 */
export interface CompanyStatistic {
    /**
     * 
     * @type {string}
     * @memberof CompanyStatistic
     */
    'company'?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyStatistic
     */
    'totalEmployee'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyStatistic
     */
    'office'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyStatistic
     */
    'home'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyStatistic
     */
    'inactive'?: number;
    /**
     * 
     * @type {Array<CompanyStatisticBuilding>}
     * @memberof CompanyStatistic
     */
    'companyStatisticBuildings'?: Array<CompanyStatisticBuilding>;
    /**
     * 
     * @type {number}
     * @memberof CompanyStatistic
     */
    'parentalLeave'?: number;
}
/**
 * 
 * @export
 * @interface CompanyStatisticBuilding
 */
export interface CompanyStatisticBuilding {
    /**
     * 
     * @type {string}
     * @memberof CompanyStatisticBuilding
     */
    'buildingName'?: string;
    /**
     * 
     * @type {Array<CompanyStatisticFloor>}
     * @memberof CompanyStatisticBuilding
     */
    'floors'?: Array<CompanyStatisticFloor>;
}
/**
 * 
 * @export
 * @interface CompanyStatisticFloor
 */
export interface CompanyStatisticFloor {
    /**
     * 
     * @type {string}
     * @memberof CompanyStatisticFloor
     */
    'name'?: string;
    /**
     * 
     * @type {Array<CompanyStatisticRoom>}
     * @memberof CompanyStatisticFloor
     */
    'offices'?: Array<CompanyStatisticRoom>;
}
/**
 * 
 * @export
 * @interface CompanyStatisticRoom
 */
export interface CompanyStatisticRoom {
    /**
     * 
     * @type {string}
     * @memberof CompanyStatisticRoom
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyStatisticRoom
     */
    'totalEmployees'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyStatisticRoom
     */
    'reservedTables'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyStatisticRoom
     */
    'occupiedByInternTables'?: number;
}
/**
 * 
 * @export
 * @interface ConferenceRoomRequest
 */
export interface ConferenceRoomRequest {
    /**
     * 
     * @type {number}
     * @memberof ConferenceRoomRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConferenceRoomRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConferenceRoomRequest
     */
    'floorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConferenceRoomRequest
     */
    'type'?: ConferenceRoomRequestTypeEnum;
}

export const ConferenceRoomRequestTypeEnum = {
    Office: 'OFFICE',
    Conference: 'CONFERENCE',
    Other: 'OTHER'
} as const;

export type ConferenceRoomRequestTypeEnum = typeof ConferenceRoomRequestTypeEnum[keyof typeof ConferenceRoomRequestTypeEnum];

/**
 * 
 * @export
 * @interface CountryRequest
 */
export interface CountryRequest {
    /**
     * 
     * @type {string}
     * @memberof CountryRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CountryResponse
 */
export interface CountryResponse {
    /**
     * 
     * @type {number}
     * @memberof CountryResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CountryResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface DayResponse
 */
export interface DayResponse {
    /**
     * 
     * @type {string}
     * @memberof DayResponse
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DayResponse
     */
    'status'?: DayResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DayResponse
     */
    'timeInSpace'?: string;
    /**
     * 
     * @type {string}
     * @memberof DayResponse
     */
    'exitDateTime'?: string;
}

export const DayResponseStatusEnum = {
    NoEntry: 'NO_ENTRY',
    StillInside: 'STILL_INSIDE',
    ExitAfter: 'EXIT_AFTER',
    ExitBefore: 'EXIT_BEFORE',
    ExitBeforeBelowMin: 'EXIT_BEFORE_BELOW_MIN',
    ExitBeforeBelowBareMin: 'EXIT_BEFORE_BELOW_BARE_MIN'
} as const;

export type DayResponseStatusEnum = typeof DayResponseStatusEnum[keyof typeof DayResponseStatusEnum];

/**
 * 
 * @export
 * @interface EmployeeDetailsWithReservations
 */
export interface EmployeeDetailsWithReservations {
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'employee'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'building'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'floor'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'office'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDetailsWithReservations
     */
    'address'?: string;
    /**
     * 
     * @type {Array<WorkstationReservationResponse>}
     * @memberof EmployeeDetailsWithReservations
     */
    'reservations'?: Array<WorkstationReservationResponse>;
}
/**
 * 
 * @export
 * @interface EmployeeRequest
 */
export interface EmployeeRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRequest
     */
    'additionalNote'?: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRequest
     */
    'reasonForDeactivation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRequest
     */
    'workstation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRequest
     */
    'accessControlNumber'?: string;
}
/**
 * 
 * @export
 * @interface EmployeeResponse
 */
export interface EmployeeResponse {
    /**
     * 
     * @type {number}
     * @memberof EmployeeResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'additionalNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'reasonForDeactivation'?: string;
    /**
     * 
     * @type {CompanyResponse}
     * @memberof EmployeeResponse
     */
    'company'?: CompanyResponse;
    /**
     * 
     * @type {WorkstationResponse}
     * @memberof EmployeeResponse
     */
    'workstation'?: WorkstationResponse;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'role'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeResponse
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'accessControlNumber'?: string;
}
/**
 * 
 * @export
 * @interface EmployeeResponseLite
 */
export interface EmployeeResponseLite {
    /**
     * 
     * @type {number}
     * @memberof EmployeeResponseLite
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseLite
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseLite
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseLite
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface EmployeeResponseWithReservations
 */
export interface EmployeeResponseWithReservations {
    /**
     * 
     * @type {number}
     * @memberof EmployeeResponseWithReservations
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseWithReservations
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseWithReservations
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseWithReservations
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseWithReservations
     */
    'additionalNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseWithReservations
     */
    'reasonForDeactivation'?: string;
    /**
     * 
     * @type {CompanyResponse}
     * @memberof EmployeeResponseWithReservations
     */
    'company'?: CompanyResponse;
    /**
     * 
     * @type {WorkstationResponse}
     * @memberof EmployeeResponseWithReservations
     */
    'workstation'?: WorkstationResponse;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseWithReservations
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseWithReservations
     */
    'role'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeResponseWithReservations
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponseWithReservations
     */
    'accessControlNumber'?: string;
    /**
     * 
     * @type {Array<WorkstationReservationResponse>}
     * @memberof EmployeeResponseWithReservations
     */
    'reservations'?: Array<WorkstationReservationResponse>;
}
/**
 * 
 * @export
 * @interface EmployeeUpdateRequest
 */
export interface EmployeeUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeUpdateRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'additionalNote'?: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeUpdateRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'reasonForDeactivation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'workstation'?: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeUpdateRequest
     */
    'floorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'accessControlNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeUpdateRequest
     */
    'role'?: EmployeeUpdateRequestRoleEnum;
}

export const EmployeeUpdateRequestRoleEnum = {
    Admin: 'ADMIN',
    SuperAdmin: 'SUPER_ADMIN',
    User: 'USER'
} as const;

export type EmployeeUpdateRequestRoleEnum = typeof EmployeeUpdateRequestRoleEnum[keyof typeof EmployeeUpdateRequestRoleEnum];

/**
 * 
 * @export
 * @interface EmployeeWithoutEventStatisticsResponse
 */
export interface EmployeeWithoutEventStatisticsResponse {
    /**
     * 
     * @type {string}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'employee'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'building'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'floor'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'office'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'isOccupied'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeWithoutEventStatisticsResponse
     */
    'devLeadName'?: string;
}
/**
 * @type EquipmentResponse
 * @export
 */
export type EquipmentResponse = { equipmentType: 'ROOM' } & RoomEquipmentResponse | { equipmentType: 'WORKSTATION' } & WorkstationEquipmentResponse;

/**
 * 
 * @export
 * @interface FloorOccupancyFailure
 */
export interface FloorOccupancyFailure {
    /**
     * 
     * @type {string}
     * @memberof FloorOccupancyFailure
     */
    'workstationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FloorOccupancyFailure
     */
    'type'?: FloorOccupancyFailureTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FloorOccupancyFailure
     */
    'message'?: string;
}

export const FloorOccupancyFailureTypeEnum = {
    DuplicateWorkstation: 'DUPLICATE_WORKSTATION',
    NotInFloorMap: 'NOT_IN_FLOOR_MAP',
    MissingFromWorkstationList: 'MISSING_FROM_WORKSTATION_LIST',
    WorkstationOnAnotherFloor: 'WORKSTATION_ON_ANOTHER_FLOOR',
    UnknownRoom: 'UNKNOWN_ROOM',
    MissingLabel: 'MISSING_LABEL',
    UnknownEmployee: 'UNKNOWN_EMPLOYEE',
    EmployeeAssignedTwice: 'EMPLOYEE_ASSIGNED_TWICE',
    EmployeeAssignedOnAnotherFloor: 'EMPLOYEE_ASSIGNED_ON_ANOTHER_FLOOR',
    LastActiveDateOnPrimaryAssignment: 'LAST_ACTIVE_DATE_ON_PRIMARY_ASSIGNMENT'
} as const;

export type FloorOccupancyFailureTypeEnum = typeof FloorOccupancyFailureTypeEnum[keyof typeof FloorOccupancyFailureTypeEnum];

/**
 * 
 * @export
 * @interface FloorOccupancyValidationResponse
 */
export interface FloorOccupancyValidationResponse {
    /**
     * 
     * @type {string}
     * @memberof FloorOccupancyValidationResponse
     */
    'error'?: string;
    /**
     * 
     * @type {Array<FloorOccupancyFailure>}
     * @memberof FloorOccupancyValidationResponse
     */
    'failures'?: Array<FloorOccupancyFailure>;
}
/**
 * 
 * @export
 * @interface FloorResponse
 */
export interface FloorResponse {
    /**
     * 
     * @type {number}
     * @memberof FloorResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FloorResponse
     */
    'nameForAdmins'?: string;
    /**
     * 
     * @type {string}
     * @memberof FloorResponse
     */
    'nameForUsers'?: string;
    /**
     * 
     * @type {number}
     * @memberof FloorResponse
     */
    'level'?: number;
    /**
     * 
     * @type {number}
     * @memberof FloorResponse
     */
    'floorMapId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FloorResponse
     */
    'mapRevision'?: number;
}
/**
 * 
 * @export
 * @interface FloorUpdateInBuildingRequest
 */
export interface FloorUpdateInBuildingRequest {
    /**
     * 
     * @type {number}
     * @memberof FloorUpdateInBuildingRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FloorUpdateInBuildingRequest
     */
    'nameForAdmins'?: string;
    /**
     * 
     * @type {string}
     * @memberof FloorUpdateInBuildingRequest
     */
    'nameForUsers'?: string;
    /**
     * 
     * @type {number}
     * @memberof FloorUpdateInBuildingRequest
     */
    'level'?: number;
}
/**
 * 
 * @export
 * @interface FloorWithBuildingInfoResponse
 */
export interface FloorWithBuildingInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof FloorWithBuildingInfoResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FloorWithBuildingInfoResponse
     */
    'nameForAdmins'?: string;
    /**
     * 
     * @type {string}
     * @memberof FloorWithBuildingInfoResponse
     */
    'nameForUsers'?: string;
    /**
     * 
     * @type {number}
     * @memberof FloorWithBuildingInfoResponse
     */
    'level'?: number;
    /**
     * 
     * @type {number}
     * @memberof FloorWithBuildingInfoResponse
     */
    'floorMapId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FloorWithBuildingInfoResponse
     */
    'mapRevision'?: number;
    /**
     * 
     * @type {BuildingResponse}
     * @memberof FloorWithBuildingInfoResponse
     */
    'building'?: BuildingResponse;
}
/**
 * 
 * @export
 * @interface FloorWorkstationRequest
 */
export interface FloorWorkstationRequest {
    /**
     * 
     * @type {string}
     * @memberof FloorWorkstationRequest
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof FloorWorkstationRequest
     */
    'roomId'?: number;
    /**
     * 
     * @type {WorkstationOccupancyRequest}
     * @memberof FloorWorkstationRequest
     */
    'occupancy'?: WorkstationOccupancyRequest;
}
/**
 * 
 * @export
 * @interface GeneralStatistic
 */
export interface GeneralStatistic {
    /**
     * 
     * @type {string}
     * @memberof GeneralStatistic
     */
    'company'?: string;
    /**
     * 
     * @type {number}
     * @memberof GeneralStatistic
     */
    'totalEmployee'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralStatistic
     */
    'office'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralStatistic
     */
    'home'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralStatistic
     */
    'inactive'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralStatistic
     */
    'totalWorkstation'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralStatistic
     */
    'parentalLeave'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralStatistic
     */
    'available'?: number;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface OfficeRoomRequest
 */
export interface OfficeRoomRequest {
    /**
     * 
     * @type {number}
     * @memberof OfficeRoomRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfficeRoomRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof OfficeRoomRequest
     */
    'floorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfficeRoomRequest
     */
    'type'?: OfficeRoomRequestTypeEnum;
}

export const OfficeRoomRequestTypeEnum = {
    Office: 'OFFICE',
    Conference: 'CONFERENCE',
    Other: 'OTHER'
} as const;

export type OfficeRoomRequestTypeEnum = typeof OfficeRoomRequestTypeEnum[keyof typeof OfficeRoomRequestTypeEnum];

/**
 * 
 * @export
 * @interface OtherRoomRequest
 */
export interface OtherRoomRequest {
    /**
     * 
     * @type {number}
     * @memberof OtherRoomRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OtherRoomRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof OtherRoomRequest
     */
    'floorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OtherRoomRequest
     */
    'type'?: OtherRoomRequestTypeEnum;
}

export const OtherRoomRequestTypeEnum = {
    Office: 'OFFICE',
    Conference: 'CONFERENCE',
    Other: 'OTHER'
} as const;

export type OtherRoomRequestTypeEnum = typeof OtherRoomRequestTypeEnum[keyof typeof OtherRoomRequestTypeEnum];

/**
 * 
 * @export
 * @interface ReplacementTokenRequest
 */
export interface ReplacementTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof ReplacementTokenRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementTokenRequest
     */
    'accessControlNumber'?: string;
}
/**
 * 
 * @export
 * @interface ReplacementTokenResponse
 */
export interface ReplacementTokenResponse {
    /**
     * 
     * @type {number}
     * @memberof ReplacementTokenResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReplacementTokenResponse
     */
    'employeeName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplacementTokenResponse
     */
    'employeeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReplacementTokenResponse
     */
    'accessControlNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementTokenResponse
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementTokenResponse
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementTokenResponse
     */
    'actionPerformedByEmployeeName'?: string;
}
/**
 * 
 * @export
 * @interface RoomEquipmentRequest
 */
export interface RoomEquipmentRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof RoomEquipmentRequest
     */
    'inventoryNumbers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RoomEquipmentResponse
 */
export interface RoomEquipmentResponse {
    /**
     * 
     * @type {number}
     * @memberof RoomEquipmentResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoomEquipmentResponse
     */
    'inventoryNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomEquipmentResponse
     */
    'equipmentType'?: string;
    /**
     * 
     * @type {RoomResponse}
     * @memberof RoomEquipmentResponse
     */
    'room'?: RoomResponse;
}
/**
 * 
 * @export
 * @interface RoomResponse
 */
export interface RoomResponse {
    /**
     * 
     * @type {number}
     * @memberof RoomResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoomResponse
     */
    'name'?: string;
    /**
     * 
     * @type {FloorWithBuildingInfoResponse}
     * @memberof RoomResponse
     */
    'floor'?: FloorWithBuildingInfoResponse;
    /**
     * 
     * @type {string}
     * @memberof RoomResponse
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface SetPasswordRequest
 */
export interface SetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordRequest
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface StaleMapRevisionResponse
 */
export interface StaleMapRevisionResponse {
    /**
     * 
     * @type {string}
     * @memberof StaleMapRevisionResponse
     */
    'error'?: string;
    /**
     * 
     * @type {number}
     * @memberof StaleMapRevisionResponse
     */
    'floorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StaleMapRevisionResponse
     */
    'mapRevision'?: number;
}
/**
 * 
 * @export
 * @interface TimeInSpaceEmployeeExitBeforeResponse
 */
export interface TimeInSpaceEmployeeExitBeforeResponse {
    /**
     * 
     * @type {string}
     * @memberof TimeInSpaceEmployeeExitBeforeResponse
     */
    'employeeFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeInSpaceEmployeeExitBeforeResponse
     */
    'employeeCardNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimeInSpaceEmployeeExitBeforeResponse
     */
    'employeeId'?: number;
    /**
     * 
     * @type {Array<DayResponse>}
     * @memberof TimeInSpaceEmployeeExitBeforeResponse
     */
    'data'?: Array<DayResponse>;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface WorkspaceUpdatesResponse
 */
export interface WorkspaceUpdatesResponse {
    /**
     * 
     * @type {number}
     * @memberof WorkspaceUpdatesResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceUpdatesResponse
     */
    'employeeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceUpdatesResponse
     */
    'employeeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceUpdatesResponse
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceUpdatesResponse
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceUpdatesResponse
     */
    'action'?: WorkspaceUpdatesResponseActionEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceUpdatesResponse
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceUpdatesResponse
     */
    'actionPerformedByEmployeeName'?: string;
}

export const WorkspaceUpdatesResponseActionEnum = {
    Detach: 'DETACH',
    Attach: 'ATTACH'
} as const;

export type WorkspaceUpdatesResponseActionEnum = typeof WorkspaceUpdatesResponseActionEnum[keyof typeof WorkspaceUpdatesResponseActionEnum];

/**
 * 
 * @export
 * @interface WorkstationEquipmentRequest
 */
export interface WorkstationEquipmentRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkstationEquipmentRequest
     */
    'inventoryNumbers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WorkstationEquipmentResponse
 */
export interface WorkstationEquipmentResponse {
    /**
     * 
     * @type {number}
     * @memberof WorkstationEquipmentResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationEquipmentResponse
     */
    'inventoryNumber'?: string;
    /**
     * 
     * @type {WorkstationResponse}
     * @memberof WorkstationEquipmentResponse
     */
    'workstation'?: WorkstationResponse;
}
/**
 * 
 * @export
 * @interface WorkstationOccupancyInternRequest
 */
export interface WorkstationOccupancyInternRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyInternRequest
     */
    'type': WorkstationOccupancyInternRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyInternRequest
     */
    'additionalInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyInternRequest
     */
    'svgDisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyInternRequest
     */
    'svgOrganizationLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyInternRequest
     */
    'lastActiveDate'?: string | null;
}

export const WorkstationOccupancyInternRequestTypeEnum = {
    Intern: 'INTERN'
} as const;

export type WorkstationOccupancyInternRequestTypeEnum = typeof WorkstationOccupancyInternRequestTypeEnum[keyof typeof WorkstationOccupancyInternRequestTypeEnum];

/**
 * 
 * @export
 * @interface WorkstationOccupancyPrimaryAssignmentRequest
 */
export interface WorkstationOccupancyPrimaryAssignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyPrimaryAssignmentRequest
     */
    'type': WorkstationOccupancyPrimaryAssignmentRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyPrimaryAssignmentRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyPrimaryAssignmentRequest
     */
    'svgDisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyPrimaryAssignmentRequest
     */
    'svgOrganizationLabel'?: string;
}

export const WorkstationOccupancyPrimaryAssignmentRequestTypeEnum = {
    Employee: 'EMPLOYEE'
} as const;

export type WorkstationOccupancyPrimaryAssignmentRequestTypeEnum = typeof WorkstationOccupancyPrimaryAssignmentRequestTypeEnum[keyof typeof WorkstationOccupancyPrimaryAssignmentRequestTypeEnum];

/**
 * @type WorkstationOccupancyRequest
 * @export
 */
export type WorkstationOccupancyRequest = { type: 'EMPLOYEE' } & WorkstationOccupancyPrimaryAssignmentRequest | { type: 'INTERN' } & WorkstationOccupancyInternRequest | { type: 'RESERVED' } & WorkstationOccupancyReservationRequest;

/**
 * 
 * @export
 * @interface WorkstationOccupancyReservationRequest
 */
export interface WorkstationOccupancyReservationRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyReservationRequest
     */
    'type': WorkstationOccupancyReservationRequestTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WorkstationOccupancyReservationRequest
     */
    'employeeId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyReservationRequest
     */
    'additionalInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyReservationRequest
     */
    'svgDisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyReservationRequest
     */
    'svgOrganizationLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationOccupancyReservationRequest
     */
    'lastActiveDate'?: string | null;
}

export const WorkstationOccupancyReservationRequestTypeEnum = {
    Reserved: 'RESERVED'
} as const;

export type WorkstationOccupancyReservationRequestTypeEnum = typeof WorkstationOccupancyReservationRequestTypeEnum[keyof typeof WorkstationOccupancyReservationRequestTypeEnum];

/**
 * 
 * @export
 * @interface WorkstationReservationResponse
 */
export interface WorkstationReservationResponse {
    /**
     * 
     * @type {number}
     * @memberof WorkstationReservationResponse
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationReservationResponse
     */
    'employeeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationReservationResponse
     */
    'workstationId'?: string;
    /**
     * 
     * @type {WorkstationResponse}
     * @memberof WorkstationReservationResponse
     */
    'workstation'?: WorkstationResponse;
    /**
     * 
     * @type {string}
     * @memberof WorkstationReservationResponse
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationReservationResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationReservationResponse
     */
    'building'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationReservationResponse
     */
    'floor'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationReservationResponse
     */
    'office'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationReservationResponse
     */
    'actionPerformedByEmployeeName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationReservationResponse
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkstationReservationResponse
     */
    'lastActiveDate'?: string | null;
}
/**
 * 
 * @export
 * @interface WorkstationResponse
 */
export interface WorkstationResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkstationResponse
     */
    'id'?: string;
    /**
     * 
     * @type {RoomResponse}
     * @memberof WorkstationResponse
     */
    'room'?: RoomResponse;
}
/**
 * 
 * @export
 * @interface WorkstationStatistic
 */
export interface WorkstationStatistic {
    /**
     * 
     * @type {string}
     * @memberof WorkstationStatistic
     */
    'employee'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationStatistic
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationStatistic
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationStatistic
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationStatistic
     */
    'building'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationStatistic
     */
    'floor'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationStatistic
     */
    'office'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationStatistic
     */
    'isOccupied'?: boolean;
}

/**
 * AcsEventsControllerApi - axios parameter creator
 * @export
 */
export const AcsEventsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [afterEventId] Return all events newer than this exclusive cursor.
         * @param {number} [beforeEventId] Return older history before this exclusive cursor.
         * @param {number} [limit] History page size; refreshes return all newer events.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAcsEvents: async (afterEventId?: number, beforeEventId?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/acs-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (afterEventId !== undefined) {
                localVarQueryParameter['afterEventId'] = afterEventId;
            }

            if (beforeEventId !== undefined) {
                localVarQueryParameter['beforeEventId'] = beforeEventId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AcsEventsControllerApi - functional programming interface
 * @export
 */
export const AcsEventsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AcsEventsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [afterEventId] Return all events newer than this exclusive cursor.
         * @param {number} [beforeEventId] Return older history before this exclusive cursor.
         * @param {number} [limit] History page size; refreshes return all newer events.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAcsEvents(afterEventId?: number, beforeEventId?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcsEventsPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAcsEvents(afterEventId, beforeEventId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AcsEventsControllerApi.getAcsEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AcsEventsControllerApi - factory interface
 * @export
 */
export const AcsEventsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AcsEventsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [afterEventId] Return all events newer than this exclusive cursor.
         * @param {number} [beforeEventId] Return older history before this exclusive cursor.
         * @param {number} [limit] History page size; refreshes return all newer events.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAcsEvents(afterEventId?: number, beforeEventId?: number, limit?: number, options?: any): AxiosPromise<AcsEventsPageResponse> {
            return localVarFp.getAcsEvents(afterEventId, beforeEventId, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AcsEventsControllerApi - object-oriented interface
 * @export
 * @class AcsEventsControllerApi
 * @extends {BaseAPI}
 */
export class AcsEventsControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [afterEventId] Return all events newer than this exclusive cursor.
     * @param {number} [beforeEventId] Return older history before this exclusive cursor.
     * @param {number} [limit] History page size; refreshes return all newer events.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AcsEventsControllerApi
     */
    public getAcsEvents(afterEventId?: number, beforeEventId?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return AcsEventsControllerApiFp(this.configuration).getAcsEvents(afterEventId, beforeEventId, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminControllerApi - axios parameter creator
 * @export
 */
export const AdminControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmin: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAdmin', 'id', id)
            const localVarPath = `/api/admins/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminById', 'id', id)
            const localVarPath = `/api/admins/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdmins: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminRequest} adminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdmin: async (adminRequest: AdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminRequest' is not null or undefined
            assertParamExists('saveAdmin', 'adminRequest', adminRequest)
            const localVarPath = `/api/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AdminRequest} adminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmin: async (id: number, adminRequest: AdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAdmin', 'id', id)
            // verify required parameter 'adminRequest' is not null or undefined
            assertParamExists('updateAdmin', 'adminRequest', adminRequest)
            const localVarPath = `/api/admins/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminControllerApi - functional programming interface
 * @export
 */
export const AdminControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdmin(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdmin(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.deleteAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getAdminById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAdmins(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAdmins(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getAllAdmins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminRequest} adminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAdmin(adminRequest: AdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAdmin(adminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.saveAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {AdminRequest} adminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdmin(id: number, adminRequest: AdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdmin(id, adminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.updateAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminControllerApi - factory interface
 * @export
 */
export const AdminControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmin(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.deleteAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminById(id: number, options?: any): AxiosPromise<AdminResponse> {
            return localVarFp.getAdminById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdmins(options?: any): AxiosPromise<Array<AdminResponse>> {
            return localVarFp.getAllAdmins(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminRequest} adminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdmin(adminRequest: AdminRequest, options?: any): AxiosPromise<AdminResponse> {
            return localVarFp.saveAdmin(adminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AdminRequest} adminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdmin(id: number, adminRequest: AdminRequest, options?: any): AxiosPromise<AdminResponse> {
            return localVarFp.updateAdmin(id, adminRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminControllerApi - object-oriented interface
 * @export
 * @class AdminControllerApi
 * @extends {BaseAPI}
 */
export class AdminControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteAdmin(id: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).deleteAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getAdminById(id: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getAdminById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public getAllAdmins(options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getAllAdmins(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminRequest} adminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public saveAdmin(adminRequest: AdminRequest, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).saveAdmin(adminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {AdminRequest} adminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public updateAdmin(id: number, adminRequest: AdminRequest, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).updateAdmin(id, adminRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationControllerApi - axios parameter creator
 * @export
 */
export const AuthenticationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('changePassword', 'username', username)
            const localVarPath = `/auth/forget-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetPasswordRequest} setPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePassword: async (setPasswordRequest: SetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setPasswordRequest' is not null or undefined
            assertParamExists('savePassword', 'setPasswordRequest', setPasswordRequest)
            const localVarPath = `/auth/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationControllerApi - functional programming interface
 * @export
 */
export const AuthenticationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetPasswordRequest} setPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePassword(setPasswordRequest: SetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePassword(setPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.savePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationControllerApi - factory interface
 * @export
 */
export const AuthenticationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(username: string, options?: any): AxiosPromise<string> {
            return localVarFp.changePassword(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options?: any): AxiosPromise<string> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetPasswordRequest} setPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePassword(setPasswordRequest: SetPasswordRequest, options?: any): AxiosPromise<UserResponse> {
            return localVarFp.savePassword(setPasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationControllerApi - object-oriented interface
 * @export
 * @class AuthenticationControllerApi
 * @extends {BaseAPI}
 */
export class AuthenticationControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public changePassword(username: string, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).changePassword(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public login(loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).login(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetPasswordRequest} setPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public savePassword(setPasswordRequest: SetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).savePassword(setPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BuildingControllerApi - axios parameter creator
 * @export
 */
export const BuildingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBuilding: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBuilding', 'id', id)
            const localVarPath = `/api/buildings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBuildings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/buildings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBuildingById', 'id', id)
            const localVarPath = `/api/buildings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BuildingRequest} buildingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBuilding: async (buildingRequest: BuildingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingRequest' is not null or undefined
            assertParamExists('saveBuilding', 'buildingRequest', buildingRequest)
            const localVarPath = `/api/buildings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {BuildingUpdateRequest} buildingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBuilding: async (id: number, buildingUpdateRequest: BuildingUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBuilding', 'id', id)
            // verify required parameter 'buildingUpdateRequest' is not null or undefined
            assertParamExists('updateBuilding', 'buildingUpdateRequest', buildingUpdateRequest)
            const localVarPath = `/api/buildings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buildingUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuildingControllerApi - functional programming interface
 * @export
 */
export const BuildingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuildingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBuilding(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingWithFloorInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBuilding(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingControllerApi.deleteBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBuildings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingWithFloorInfoResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBuildings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingControllerApi.getAllBuildings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuildingById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingWithFloorInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuildingById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingControllerApi.getBuildingById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BuildingRequest} buildingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBuilding(buildingRequest: BuildingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingWithFloorInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBuilding(buildingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingControllerApi.saveBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {BuildingUpdateRequest} buildingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBuilding(id: number, buildingUpdateRequest: BuildingUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingWithFloorInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBuilding(id, buildingUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuildingControllerApi.updateBuilding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BuildingControllerApi - factory interface
 * @export
 */
export const BuildingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuildingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBuilding(id: number, options?: any): AxiosPromise<BuildingWithFloorInfoResponse> {
            return localVarFp.deleteBuilding(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBuildings(options?: any): AxiosPromise<Array<BuildingWithFloorInfoResponse>> {
            return localVarFp.getAllBuildings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingById(id: number, options?: any): AxiosPromise<BuildingWithFloorInfoResponse> {
            return localVarFp.getBuildingById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BuildingRequest} buildingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBuilding(buildingRequest: BuildingRequest, options?: any): AxiosPromise<BuildingWithFloorInfoResponse> {
            return localVarFp.saveBuilding(buildingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {BuildingUpdateRequest} buildingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBuilding(id: number, buildingUpdateRequest: BuildingUpdateRequest, options?: any): AxiosPromise<BuildingWithFloorInfoResponse> {
            return localVarFp.updateBuilding(id, buildingUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuildingControllerApi - object-oriented interface
 * @export
 * @class BuildingControllerApi
 * @extends {BaseAPI}
 */
export class BuildingControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingControllerApi
     */
    public deleteBuilding(id: number, options?: RawAxiosRequestConfig) {
        return BuildingControllerApiFp(this.configuration).deleteBuilding(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingControllerApi
     */
    public getAllBuildings(options?: RawAxiosRequestConfig) {
        return BuildingControllerApiFp(this.configuration).getAllBuildings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingControllerApi
     */
    public getBuildingById(id: number, options?: RawAxiosRequestConfig) {
        return BuildingControllerApiFp(this.configuration).getBuildingById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BuildingRequest} buildingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingControllerApi
     */
    public saveBuilding(buildingRequest: BuildingRequest, options?: RawAxiosRequestConfig) {
        return BuildingControllerApiFp(this.configuration).saveBuilding(buildingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {BuildingUpdateRequest} buildingUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingControllerApi
     */
    public updateBuilding(id: number, buildingUpdateRequest: BuildingUpdateRequest, options?: RawAxiosRequestConfig) {
        return BuildingControllerApiFp(this.configuration).updateBuilding(id, buildingUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CityControllerApi - axios parameter creator
 * @export
 */
export const CityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCity: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCity', 'id', id)
            const localVarPath = `/api/cities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCityById', 'id', id)
            const localVarPath = `/api/cities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CityRequest} cityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCity: async (cityRequest: CityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityRequest' is not null or undefined
            assertParamExists('saveCity', 'cityRequest', cityRequest)
            const localVarPath = `/api/cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CityRequest} cityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCity: async (id: number, cityRequest: CityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCity', 'id', id)
            // verify required parameter 'cityRequest' is not null or undefined
            assertParamExists('updateCity', 'cityRequest', cityRequest)
            const localVarPath = `/api/cities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CityControllerApi - functional programming interface
 * @export
 */
export const CityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCity(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CityControllerApi.deleteCity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CityControllerApi.getAllCities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCityById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCityById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CityControllerApi.getCityById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CityRequest} cityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCity(cityRequest: CityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCity(cityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CityControllerApi.saveCity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {CityRequest} cityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCity(id: number, cityRequest: CityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCity(id, cityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CityControllerApi.updateCity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CityControllerApi - factory interface
 * @export
 */
export const CityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CityControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCity(id: number, options?: any): AxiosPromise<CityResponse> {
            return localVarFp.deleteCity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCities(options?: any): AxiosPromise<Array<CityResponse>> {
            return localVarFp.getAllCities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityById(id: number, options?: any): AxiosPromise<CityResponse> {
            return localVarFp.getCityById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CityRequest} cityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCity(cityRequest: CityRequest, options?: any): AxiosPromise<CityResponse> {
            return localVarFp.saveCity(cityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CityRequest} cityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCity(id: number, cityRequest: CityRequest, options?: any): AxiosPromise<CityResponse> {
            return localVarFp.updateCity(id, cityRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CityControllerApi - object-oriented interface
 * @export
 * @class CityControllerApi
 * @extends {BaseAPI}
 */
export class CityControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityControllerApi
     */
    public deleteCity(id: number, options?: RawAxiosRequestConfig) {
        return CityControllerApiFp(this.configuration).deleteCity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityControllerApi
     */
    public getAllCities(options?: RawAxiosRequestConfig) {
        return CityControllerApiFp(this.configuration).getAllCities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityControllerApi
     */
    public getCityById(id: number, options?: RawAxiosRequestConfig) {
        return CityControllerApiFp(this.configuration).getCityById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CityRequest} cityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityControllerApi
     */
    public saveCity(cityRequest: CityRequest, options?: RawAxiosRequestConfig) {
        return CityControllerApiFp(this.configuration).saveCity(cityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CityRequest} cityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityControllerApi
     */
    public updateCity(id: number, cityRequest: CityRequest, options?: RawAxiosRequestConfig) {
        return CityControllerApiFp(this.configuration).updateCity(id, cityRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyControllerApi - axios parameter creator
 * @export
 */
export const CompanyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCompany', 'id', id)
            const localVarPath = `/api/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyById', 'id', id)
            const localVarPath = `/api/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyRequest} companyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompany: async (companyRequest: CompanyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyRequest' is not null or undefined
            assertParamExists('saveCompany', 'companyRequest', companyRequest)
            const localVarPath = `/api/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyRequest} companyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: async (id: number, companyRequest: CompanyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompany', 'id', id)
            // verify required parameter 'companyRequest' is not null or undefined
            assertParamExists('updateCompany', 'companyRequest', companyRequest)
            const localVarPath = `/api/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyControllerApi - functional programming interface
 * @export
 */
export const CompanyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompany(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompany(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyControllerApi.deleteCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCompanies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCompanies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyControllerApi.getAllCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyControllerApi.getCompanyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompanyRequest} companyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCompany(companyRequest: CompanyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCompany(companyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyControllerApi.saveCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyRequest} companyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompany(id: number, companyRequest: CompanyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompany(id, companyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyControllerApi.updateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyControllerApi - factory interface
 * @export
 */
export const CompanyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany(id: number, options?: any): AxiosPromise<CompanyResponse> {
            return localVarFp.deleteCompany(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanies(options?: any): AxiosPromise<Array<CompanyResponse>> {
            return localVarFp.getAllCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyById(id: number, options?: any): AxiosPromise<CompanyResponse> {
            return localVarFp.getCompanyById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyRequest} companyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompany(companyRequest: CompanyRequest, options?: any): AxiosPromise<CompanyResponse> {
            return localVarFp.saveCompany(companyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyRequest} companyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(id: number, companyRequest: CompanyRequest, options?: any): AxiosPromise<CompanyResponse> {
            return localVarFp.updateCompany(id, companyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyControllerApi - object-oriented interface
 * @export
 * @class CompanyControllerApi
 * @extends {BaseAPI}
 */
export class CompanyControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyControllerApi
     */
    public deleteCompany(id: number, options?: RawAxiosRequestConfig) {
        return CompanyControllerApiFp(this.configuration).deleteCompany(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyControllerApi
     */
    public getAllCompanies(options?: RawAxiosRequestConfig) {
        return CompanyControllerApiFp(this.configuration).getAllCompanies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyControllerApi
     */
    public getCompanyById(id: number, options?: RawAxiosRequestConfig) {
        return CompanyControllerApiFp(this.configuration).getCompanyById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyRequest} companyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyControllerApi
     */
    public saveCompany(companyRequest: CompanyRequest, options?: RawAxiosRequestConfig) {
        return CompanyControllerApiFp(this.configuration).saveCompany(companyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CompanyRequest} companyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyControllerApi
     */
    public updateCompany(id: number, companyRequest: CompanyRequest, options?: RawAxiosRequestConfig) {
        return CompanyControllerApiFp(this.configuration).updateCompany(id, companyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CountryControllerApi - axios parameter creator
 * @export
 */
export const CountryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCountry: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCountry', 'id', id)
            const localVarPath = `/api/countries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCountryById', 'id', id)
            const localVarPath = `/api/countries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CountryRequest} countryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCountry: async (countryRequest: CountryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryRequest' is not null or undefined
            assertParamExists('saveCountry', 'countryRequest', countryRequest)
            const localVarPath = `/api/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CountryRequest} countryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCountry: async (id: number, countryRequest: CountryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCountry', 'id', id)
            // verify required parameter 'countryRequest' is not null or undefined
            assertParamExists('updateCountry', 'countryRequest', countryRequest)
            const localVarPath = `/api/countries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountryControllerApi - functional programming interface
 * @export
 */
export const CountryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCountry(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCountry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.deleteCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.getAllCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountryById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountryById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.getCountryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CountryRequest} countryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCountry(countryRequest: CountryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCountry(countryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.saveCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {CountryRequest} countryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCountry(id: number, countryRequest: CountryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCountry(id, countryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.updateCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CountryControllerApi - factory interface
 * @export
 */
export const CountryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCountry(id: number, options?: any): AxiosPromise<CountryResponse> {
            return localVarFp.deleteCountry(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCountries(options?: any): AxiosPromise<Array<CountryResponse>> {
            return localVarFp.getAllCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryById(id: number, options?: any): AxiosPromise<CountryResponse> {
            return localVarFp.getCountryById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CountryRequest} countryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCountry(countryRequest: CountryRequest, options?: any): AxiosPromise<CountryResponse> {
            return localVarFp.saveCountry(countryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CountryRequest} countryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCountry(id: number, countryRequest: CountryRequest, options?: any): AxiosPromise<CountryResponse> {
            return localVarFp.updateCountry(id, countryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountryControllerApi - object-oriented interface
 * @export
 * @class CountryControllerApi
 * @extends {BaseAPI}
 */
export class CountryControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public deleteCountry(id: number, options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).deleteCountry(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public getAllCountries(options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).getAllCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public getCountryById(id: number, options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).getCountryById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CountryRequest} countryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public saveCountry(countryRequest: CountryRequest, options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).saveCountry(countryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CountryRequest} countryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public updateCountry(id: number, countryRequest: CountryRequest, options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).updateCountry(id, countryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeControllerApi - axios parameter creator
 * @export
 */
export const EmployeeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEmployee', 'id', id)
            const localVarPath = `/api/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableEmployee: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('enableEmployee', 'username', username)
            const localVarPath = `/api/employees/enable/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssignedEmployees: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/employees/assigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmployees: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmployeesDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/employees/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmployeeById', 'id', id)
            const localVarPath = `/api/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/employees/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkstationUpdatesForEmployeeId: async (employeeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getWorkstationUpdatesForEmployeeId', 'employeeId', employeeId)
            const localVarPath = `/api/employees/{employeeId}/workstation-updates`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmployeeRequest} employeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployee: async (employeeRequest: EmployeeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeRequest' is not null or undefined
            assertParamExists('saveEmployee', 'employeeRequest', employeeRequest)
            const localVarPath = `/api/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployee1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/employees/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSetPasswordEmails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/employees/send-set-password-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncLdapUser: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncLdapUser', 'id', id)
            const localVarPath = `/api/employees/ldap/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {EmployeeUpdateRequest} employeeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployee: async (id: number, employeeUpdateRequest: EmployeeUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEmployee', 'id', id)
            // verify required parameter 'employeeUpdateRequest' is not null or undefined
            assertParamExists('updateEmployee', 'employeeUpdateRequest', employeeUpdateRequest)
            const localVarPath = `/api/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeControllerApi - functional programming interface
 * @export
 */
export const EmployeeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmployee(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmployee(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.deleteEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableEmployee(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableEmployee(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.enableEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAssignedEmployees(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeResponseWithReservations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAssignedEmployees(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.getAllAssignedEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEmployees(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEmployees(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.getAllEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEmployeesDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeDetailsWithReservations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEmployeesDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.getAllEmployeesDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.getEmployeeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.getRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkstationUpdatesForEmployeeId(employeeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkspaceUpdatesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkstationUpdatesForEmployeeId(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.getWorkstationUpdatesForEmployeeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmployeeRequest} employeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEmployee(employeeRequest: EmployeeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEmployee(employeeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.saveEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEmployee1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEmployee1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.saveEmployee1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSetPasswordEmails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSetPasswordEmails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.sendSetPasswordEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncLdapUser(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncLdapUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.syncLdapUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {EmployeeUpdateRequest} employeeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployee(id: number, employeeUpdateRequest: EmployeeUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployee(id, employeeUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeControllerApi.updateEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeControllerApi - factory interface
 * @export
 */
export const EmployeeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee(id: number, options?: any): AxiosPromise<EmployeeResponse> {
            return localVarFp.deleteEmployee(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableEmployee(username: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.enableEmployee(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssignedEmployees(options?: any): AxiosPromise<Array<EmployeeResponseWithReservations>> {
            return localVarFp.getAllAssignedEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmployees(options?: any): AxiosPromise<Array<EmployeeResponse>> {
            return localVarFp.getAllEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmployeesDetails(options?: any): AxiosPromise<Array<EmployeeDetailsWithReservations>> {
            return localVarFp.getAllEmployeesDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeById(id: number, options?: any): AxiosPromise<EmployeeResponse> {
            return localVarFp.getEmployeeById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkstationUpdatesForEmployeeId(employeeId: number, options?: any): AxiosPromise<Array<WorkspaceUpdatesResponse>> {
            return localVarFp.getWorkstationUpdatesForEmployeeId(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeRequest} employeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployee(employeeRequest: EmployeeRequest, options?: any): AxiosPromise<EmployeeResponse> {
            return localVarFp.saveEmployee(employeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployee1(options?: any): AxiosPromise<void> {
            return localVarFp.saveEmployee1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSetPasswordEmails(options?: any): AxiosPromise<UserResponse> {
            return localVarFp.sendSetPasswordEmails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncLdapUser(id: number, options?: any): AxiosPromise<EmployeeResponse> {
            return localVarFp.syncLdapUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {EmployeeUpdateRequest} employeeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployee(id: number, employeeUpdateRequest: EmployeeUpdateRequest, options?: any): AxiosPromise<EmployeeResponse> {
            return localVarFp.updateEmployee(id, employeeUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeControllerApi - object-oriented interface
 * @export
 * @class EmployeeControllerApi
 * @extends {BaseAPI}
 */
export class EmployeeControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public deleteEmployee(id: number, options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).deleteEmployee(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public enableEmployee(username: string, options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).enableEmployee(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public getAllAssignedEmployees(options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).getAllAssignedEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public getAllEmployees(options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).getAllEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public getAllEmployeesDetails(options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).getAllEmployeesDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public getEmployeeById(id: number, options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).getEmployeeById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public getRoles(options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).getRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public getWorkstationUpdatesForEmployeeId(employeeId: number, options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).getWorkstationUpdatesForEmployeeId(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeRequest} employeeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public saveEmployee(employeeRequest: EmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).saveEmployee(employeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public saveEmployee1(options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).saveEmployee1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public sendSetPasswordEmails(options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).sendSetPasswordEmails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public syncLdapUser(id: number, options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).syncLdapUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {EmployeeUpdateRequest} employeeUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeControllerApi
     */
    public updateEmployee(id: number, employeeUpdateRequest: EmployeeUpdateRequest, options?: RawAxiosRequestConfig) {
        return EmployeeControllerApiFp(this.configuration).updateEmployee(id, employeeUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EquipmentControllerApi - axios parameter creator
 * @export
 */
export const EquipmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEquipment: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/equipment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} workstationId 
         * @param {WorkstationEquipmentRequest} workstationEquipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEquipment: async (workstationId: string, workstationEquipmentRequest: WorkstationEquipmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workstationId' is not null or undefined
            assertParamExists('saveEquipment', 'workstationId', workstationId)
            // verify required parameter 'workstationEquipmentRequest' is not null or undefined
            assertParamExists('saveEquipment', 'workstationEquipmentRequest', workstationEquipmentRequest)
            const localVarPath = `/api/workstations/{workstationId}/equipment`
                .replace(`{${"workstationId"}}`, encodeURIComponent(String(workstationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workstationEquipmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roomId 
         * @param {RoomEquipmentRequest} roomEquipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRoomEquipment: async (roomId: number, roomEquipmentRequest: RoomEquipmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('saveRoomEquipment', 'roomId', roomId)
            // verify required parameter 'roomEquipmentRequest' is not null or undefined
            assertParamExists('saveRoomEquipment', 'roomEquipmentRequest', roomEquipmentRequest)
            const localVarPath = `/api/rooms/{roomId}/equipment`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roomEquipmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EquipmentControllerApi - functional programming interface
 * @export
 */
export const EquipmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EquipmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEquipment(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquipmentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEquipment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentControllerApi.getAllEquipment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} workstationId 
         * @param {WorkstationEquipmentRequest} workstationEquipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEquipment(workstationId: string, workstationEquipmentRequest: WorkstationEquipmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEquipment(workstationId, workstationEquipmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentControllerApi.saveEquipment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} roomId 
         * @param {RoomEquipmentRequest} roomEquipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRoomEquipment(roomId: number, roomEquipmentRequest: RoomEquipmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRoomEquipment(roomId, roomEquipmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentControllerApi.saveRoomEquipment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EquipmentControllerApi - factory interface
 * @export
 */
export const EquipmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EquipmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEquipment(options?: any): AxiosPromise<Array<EquipmentResponse>> {
            return localVarFp.getAllEquipment(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} workstationId 
         * @param {WorkstationEquipmentRequest} workstationEquipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEquipment(workstationId: string, workstationEquipmentRequest: WorkstationEquipmentRequest, options?: any): AxiosPromise<void> {
            return localVarFp.saveEquipment(workstationId, workstationEquipmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} roomId 
         * @param {RoomEquipmentRequest} roomEquipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRoomEquipment(roomId: number, roomEquipmentRequest: RoomEquipmentRequest, options?: any): AxiosPromise<void> {
            return localVarFp.saveRoomEquipment(roomId, roomEquipmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EquipmentControllerApi - object-oriented interface
 * @export
 * @class EquipmentControllerApi
 * @extends {BaseAPI}
 */
export class EquipmentControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    public getAllEquipment(options?: RawAxiosRequestConfig) {
        return EquipmentControllerApiFp(this.configuration).getAllEquipment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} workstationId 
     * @param {WorkstationEquipmentRequest} workstationEquipmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    public saveEquipment(workstationId: string, workstationEquipmentRequest: WorkstationEquipmentRequest, options?: RawAxiosRequestConfig) {
        return EquipmentControllerApiFp(this.configuration).saveEquipment(workstationId, workstationEquipmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} roomId 
     * @param {RoomEquipmentRequest} roomEquipmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentControllerApi
     */
    public saveRoomEquipment(roomId: number, roomEquipmentRequest: RoomEquipmentRequest, options?: RawAxiosRequestConfig) {
        return EquipmentControllerApiFp(this.configuration).saveRoomEquipment(roomId, roomEquipmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FloorControllerApi - axios parameter creator
 * @export
 */
export const FloorControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFloor: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFloor', 'id', id)
            const localVarPath = `/api/floors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFloors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/floors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFloorById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFloorById', 'id', id)
            const localVarPath = `/api/floors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSVGById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSVGById', 'id', id)
            const localVarPath = `/api/floors/downloadFile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [nameForAdmins] 
         * @param {string} [nameForUsers] 
         * @param {number} [level] 
         * @param {File} [svg] 
         * @param {number} [buildingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFloor: async (id?: number, nameForAdmins?: string, nameForUsers?: string, level?: number, svg?: File, buildingId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/floors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (id !== undefined) { 
                localVarFormParams.append('id', id as any);
            }
    
            if (nameForAdmins !== undefined) { 
                localVarFormParams.append('nameForAdmins', nameForAdmins as any);
            }
    
            if (nameForUsers !== undefined) { 
                localVarFormParams.append('nameForUsers', nameForUsers as any);
            }
    
            if (level !== undefined) { 
                localVarFormParams.append('level', level as any);
            }
    
            if (svg !== undefined) { 
                localVarFormParams.append('svg', svg as any);
            }
    
            if (buildingId !== undefined) { 
                localVarFormParams.append('buildingId', buildingId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves the floor map, the floor metadata and the occupancy of every workstation in one transaction. `workstations` is a JSON part (`Blob` with type `application/json`) holding an array of FloorWorkstationRequest.
         * @param {number} id 
         * @param {number} [id2] 
         * @param {string} [nameForAdmins] 
         * @param {string} [nameForUsers] 
         * @param {number} [level] 
         * @param {File} [svg] 
         * @param {number} [buildingId] 
         * @param {number} [mapRevision] 
         * @param {File} [workstations] JSON part holding an array of FloorWorkstationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFloorMap: async (id: number, id2?: number, nameForAdmins?: string, nameForUsers?: string, level?: number, svg?: File, buildingId?: number, mapRevision?: number, workstations?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('saveFloorMap', 'id', id)
            const localVarPath = `/api/floors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (id2 !== undefined) { 
                localVarFormParams.append('id', id2 as any);
            }
    
            if (nameForAdmins !== undefined) { 
                localVarFormParams.append('nameForAdmins', nameForAdmins as any);
            }
    
            if (nameForUsers !== undefined) { 
                localVarFormParams.append('nameForUsers', nameForUsers as any);
            }
    
            if (level !== undefined) { 
                localVarFormParams.append('level', level as any);
            }
    
            if (svg !== undefined) { 
                localVarFormParams.append('svg', svg as any);
            }
    
            if (buildingId !== undefined) { 
                localVarFormParams.append('buildingId', buildingId as any);
            }
    
            if (mapRevision !== undefined) { 
                localVarFormParams.append('mapRevision', mapRevision as any);
            }
    
            if (workstations !== undefined) { 
                localVarFormParams.append('workstations', workstations as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FloorControllerApi - functional programming interface
 * @export
 */
export const FloorControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FloorControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFloor(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorWithBuildingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFloor(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorControllerApi.deleteFloor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFloors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FloorWithBuildingInfoResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFloors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorControllerApi.getAllFloors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFloorById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorWithBuildingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFloorById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorControllerApi.getFloorById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSVGById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSVGById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorControllerApi.getSVGById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [nameForAdmins] 
         * @param {string} [nameForUsers] 
         * @param {number} [level] 
         * @param {File} [svg] 
         * @param {number} [buildingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveFloor(id?: number, nameForAdmins?: string, nameForUsers?: string, level?: number, svg?: File, buildingId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorWithBuildingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveFloor(id, nameForAdmins, nameForUsers, level, svg, buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorControllerApi.saveFloor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves the floor map, the floor metadata and the occupancy of every workstation in one transaction. `workstations` is a JSON part (`Blob` with type `application/json`) holding an array of FloorWorkstationRequest.
         * @param {number} id 
         * @param {number} [id2] 
         * @param {string} [nameForAdmins] 
         * @param {string} [nameForUsers] 
         * @param {number} [level] 
         * @param {File} [svg] 
         * @param {number} [buildingId] 
         * @param {number} [mapRevision] 
         * @param {File} [workstations] JSON part holding an array of FloorWorkstationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveFloorMap(id: number, id2?: number, nameForAdmins?: string, nameForUsers?: string, level?: number, svg?: File, buildingId?: number, mapRevision?: number, workstations?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorWithBuildingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveFloorMap(id, id2, nameForAdmins, nameForUsers, level, svg, buildingId, mapRevision, workstations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorControllerApi.saveFloorMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FloorControllerApi - factory interface
 * @export
 */
export const FloorControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FloorControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFloor(id: number, options?: any): AxiosPromise<FloorWithBuildingInfoResponse> {
            return localVarFp.deleteFloor(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFloors(options?: any): AxiosPromise<Array<FloorWithBuildingInfoResponse>> {
            return localVarFp.getAllFloors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFloorById(id: number, options?: any): AxiosPromise<FloorWithBuildingInfoResponse> {
            return localVarFp.getFloorById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSVGById(id: number, options?: any): AxiosPromise<File> {
            return localVarFp.getSVGById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [nameForAdmins] 
         * @param {string} [nameForUsers] 
         * @param {number} [level] 
         * @param {File} [svg] 
         * @param {number} [buildingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFloor(id?: number, nameForAdmins?: string, nameForUsers?: string, level?: number, svg?: File, buildingId?: number, options?: any): AxiosPromise<FloorWithBuildingInfoResponse> {
            return localVarFp.saveFloor(id, nameForAdmins, nameForUsers, level, svg, buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Saves the floor map, the floor metadata and the occupancy of every workstation in one transaction. `workstations` is a JSON part (`Blob` with type `application/json`) holding an array of FloorWorkstationRequest.
         * @param {number} id 
         * @param {number} [id2] 
         * @param {string} [nameForAdmins] 
         * @param {string} [nameForUsers] 
         * @param {number} [level] 
         * @param {File} [svg] 
         * @param {number} [buildingId] 
         * @param {number} [mapRevision] 
         * @param {File} [workstations] JSON part holding an array of FloorWorkstationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFloorMap(id: number, id2?: number, nameForAdmins?: string, nameForUsers?: string, level?: number, svg?: File, buildingId?: number, mapRevision?: number, workstations?: File, options?: any): AxiosPromise<FloorWithBuildingInfoResponse> {
            return localVarFp.saveFloorMap(id, id2, nameForAdmins, nameForUsers, level, svg, buildingId, mapRevision, workstations, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FloorControllerApi - object-oriented interface
 * @export
 * @class FloorControllerApi
 * @extends {BaseAPI}
 */
export class FloorControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FloorControllerApi
     */
    public deleteFloor(id: number, options?: RawAxiosRequestConfig) {
        return FloorControllerApiFp(this.configuration).deleteFloor(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FloorControllerApi
     */
    public getAllFloors(options?: RawAxiosRequestConfig) {
        return FloorControllerApiFp(this.configuration).getAllFloors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FloorControllerApi
     */
    public getFloorById(id: number, options?: RawAxiosRequestConfig) {
        return FloorControllerApiFp(this.configuration).getFloorById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FloorControllerApi
     */
    public getSVGById(id: number, options?: RawAxiosRequestConfig) {
        return FloorControllerApiFp(this.configuration).getSVGById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {string} [nameForAdmins] 
     * @param {string} [nameForUsers] 
     * @param {number} [level] 
     * @param {File} [svg] 
     * @param {number} [buildingId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FloorControllerApi
     */
    public saveFloor(id?: number, nameForAdmins?: string, nameForUsers?: string, level?: number, svg?: File, buildingId?: number, options?: RawAxiosRequestConfig) {
        return FloorControllerApiFp(this.configuration).saveFloor(id, nameForAdmins, nameForUsers, level, svg, buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves the floor map, the floor metadata and the occupancy of every workstation in one transaction. `workstations` is a JSON part (`Blob` with type `application/json`) holding an array of FloorWorkstationRequest.
     * @param {number} id 
     * @param {number} [id2] 
     * @param {string} [nameForAdmins] 
     * @param {string} [nameForUsers] 
     * @param {number} [level] 
     * @param {File} [svg] 
     * @param {number} [buildingId] 
     * @param {number} [mapRevision] 
     * @param {File} [workstations] JSON part holding an array of FloorWorkstationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FloorControllerApi
     */
    public saveFloorMap(id: number, id2?: number, nameForAdmins?: string, nameForUsers?: string, level?: number, svg?: File, buildingId?: number, mapRevision?: number, workstations?: File, options?: RawAxiosRequestConfig) {
        return FloorControllerApiFp(this.configuration).saveFloorMap(id, id2, nameForAdmins, nameForUsers, level, svg, buildingId, mapRevision, workstations, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReplacementTokensControllerApi - axios parameter creator
 * @export
 */
export const ReplacementTokensControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} employeeId 
         * @param {ReplacementTokenRequest} replacementTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReplacementToken: async (employeeId: number, replacementTokenRequest: ReplacementTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createReplacementToken', 'employeeId', employeeId)
            // verify required parameter 'replacementTokenRequest' is not null or undefined
            assertParamExists('createReplacementToken', 'replacementTokenRequest', replacementTokenRequest)
            const localVarPath = `/api/employees/{employeeId}/replacement-tokens`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replacementTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReplacementToken: async (employeeId: number, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteReplacementToken', 'employeeId', employeeId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteReplacementToken', 'id', id)
            const localVarPath = `/api/employees/{employeeId}/replacement-tokens/{id}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReplacementTokens: async (employeeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getAllReplacementTokens', 'employeeId', employeeId)
            const localVarPath = `/api/employees/{employeeId}/replacement-tokens`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} id 
         * @param {ReplacementTokenRequest} replacementTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReplacementToken: async (employeeId: number, id: number, replacementTokenRequest: ReplacementTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateReplacementToken', 'employeeId', employeeId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateReplacementToken', 'id', id)
            // verify required parameter 'replacementTokenRequest' is not null or undefined
            assertParamExists('updateReplacementToken', 'replacementTokenRequest', replacementTokenRequest)
            const localVarPath = `/api/employees/{employeeId}/replacement-tokens/{id}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replacementTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReplacementTokensControllerApi - functional programming interface
 * @export
 */
export const ReplacementTokensControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReplacementTokensControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} employeeId 
         * @param {ReplacementTokenRequest} replacementTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReplacementToken(employeeId: number, replacementTokenRequest: ReplacementTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplacementTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReplacementToken(employeeId, replacementTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReplacementTokensControllerApi.createReplacementToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReplacementToken(employeeId: number, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReplacementToken(employeeId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReplacementTokensControllerApi.deleteReplacementToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReplacementTokens(employeeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReplacementTokenResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReplacementTokens(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReplacementTokensControllerApi.getAllReplacementTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} id 
         * @param {ReplacementTokenRequest} replacementTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReplacementToken(employeeId: number, id: number, replacementTokenRequest: ReplacementTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplacementTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReplacementToken(employeeId, id, replacementTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReplacementTokensControllerApi.updateReplacementToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReplacementTokensControllerApi - factory interface
 * @export
 */
export const ReplacementTokensControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReplacementTokensControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} employeeId 
         * @param {ReplacementTokenRequest} replacementTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReplacementToken(employeeId: number, replacementTokenRequest: ReplacementTokenRequest, options?: any): AxiosPromise<ReplacementTokenResponse> {
            return localVarFp.createReplacementToken(employeeId, replacementTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReplacementToken(employeeId: number, id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteReplacementToken(employeeId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReplacementTokens(employeeId: number, options?: any): AxiosPromise<Array<ReplacementTokenResponse>> {
            return localVarFp.getAllReplacementTokens(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} id 
         * @param {ReplacementTokenRequest} replacementTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReplacementToken(employeeId: number, id: number, replacementTokenRequest: ReplacementTokenRequest, options?: any): AxiosPromise<ReplacementTokenResponse> {
            return localVarFp.updateReplacementToken(employeeId, id, replacementTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReplacementTokensControllerApi - object-oriented interface
 * @export
 * @class ReplacementTokensControllerApi
 * @extends {BaseAPI}
 */
export class ReplacementTokensControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} employeeId 
     * @param {ReplacementTokenRequest} replacementTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplacementTokensControllerApi
     */
    public createReplacementToken(employeeId: number, replacementTokenRequest: ReplacementTokenRequest, options?: RawAxiosRequestConfig) {
        return ReplacementTokensControllerApiFp(this.configuration).createReplacementToken(employeeId, replacementTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplacementTokensControllerApi
     */
    public deleteReplacementToken(employeeId: number, id: number, options?: RawAxiosRequestConfig) {
        return ReplacementTokensControllerApiFp(this.configuration).deleteReplacementToken(employeeId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplacementTokensControllerApi
     */
    public getAllReplacementTokens(employeeId: number, options?: RawAxiosRequestConfig) {
        return ReplacementTokensControllerApiFp(this.configuration).getAllReplacementTokens(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {number} id 
     * @param {ReplacementTokenRequest} replacementTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplacementTokensControllerApi
     */
    public updateReplacementToken(employeeId: number, id: number, replacementTokenRequest: ReplacementTokenRequest, options?: RawAxiosRequestConfig) {
        return ReplacementTokensControllerApiFp(this.configuration).updateReplacementToken(employeeId, id, replacementTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoomControllerApi - axios parameter creator
 * @export
 */
export const RoomControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRoom', 'id', id)
            const localVarPath = `/api/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRooms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRoomById', 'id', id)
            const localVarPath = `/api/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OfficeRoomRequest} officeRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save: async (officeRoomRequest: OfficeRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'officeRoomRequest' is not null or undefined
            assertParamExists('save', 'officeRoomRequest', officeRoomRequest)
            const localVarPath = `/api/rooms/office`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(officeRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConferenceRoomRequest} conferenceRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save1: async (conferenceRoomRequest: ConferenceRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conferenceRoomRequest' is not null or undefined
            assertParamExists('save1', 'conferenceRoomRequest', conferenceRoomRequest)
            const localVarPath = `/api/rooms/conference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conferenceRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtherRoomRequest} otherRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOtherRoom: async (otherRoomRequest: OtherRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otherRoomRequest' is not null or undefined
            assertParamExists('saveOtherRoom', 'otherRoomRequest', otherRoomRequest)
            const localVarPath = `/api/rooms/other`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otherRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {OfficeRoomRequest} officeRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, officeRoomRequest: OfficeRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'officeRoomRequest' is not null or undefined
            assertParamExists('update', 'officeRoomRequest', officeRoomRequest)
            const localVarPath = `/api/rooms/{id}/office`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(officeRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConferenceRoomRequest} conferenceRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1: async (id: number, conferenceRoomRequest: ConferenceRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update1', 'id', id)
            // verify required parameter 'conferenceRoomRequest' is not null or undefined
            assertParamExists('update1', 'conferenceRoomRequest', conferenceRoomRequest)
            const localVarPath = `/api/rooms/{id}/conference`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conferenceRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {OtherRoomRequest} otherRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOtherRoom: async (id: number, otherRoomRequest: OtherRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOtherRoom', 'id', id)
            // verify required parameter 'otherRoomRequest' is not null or undefined
            assertParamExists('updateOtherRoom', 'otherRoomRequest', otherRoomRequest)
            const localVarPath = `/api/rooms/{id}/other`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otherRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomControllerApi - functional programming interface
 * @export
 */
export const RoomControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoom(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoom(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.deleteRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRooms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoomResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRooms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.getAllRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.getRoomById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OfficeRoomRequest} officeRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save(officeRoomRequest: OfficeRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save(officeRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.save']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConferenceRoomRequest} conferenceRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save1(conferenceRoomRequest: ConferenceRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save1(conferenceRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.save1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtherRoomRequest} otherRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOtherRoom(otherRoomRequest: OtherRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOtherRoom(otherRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.saveOtherRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {OfficeRoomRequest} officeRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, officeRoomRequest: OfficeRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, officeRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConferenceRoomRequest} conferenceRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update1(id: number, conferenceRoomRequest: ConferenceRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update1(id, conferenceRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.update1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {OtherRoomRequest} otherRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOtherRoom(id: number, otherRoomRequest: OtherRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOtherRoom(id, otherRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomControllerApi.updateOtherRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RoomControllerApi - factory interface
 * @export
 */
export const RoomControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom(id: number, options?: any): AxiosPromise<RoomResponse> {
            return localVarFp.deleteRoom(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRooms(options?: any): AxiosPromise<Array<RoomResponse>> {
            return localVarFp.getAllRooms(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomById(id: number, options?: any): AxiosPromise<RoomResponse> {
            return localVarFp.getRoomById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OfficeRoomRequest} officeRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(officeRoomRequest: OfficeRoomRequest, options?: any): AxiosPromise<RoomResponse> {
            return localVarFp.save(officeRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConferenceRoomRequest} conferenceRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save1(conferenceRoomRequest: ConferenceRoomRequest, options?: any): AxiosPromise<RoomResponse> {
            return localVarFp.save1(conferenceRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtherRoomRequest} otherRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOtherRoom(otherRoomRequest: OtherRoomRequest, options?: any): AxiosPromise<RoomResponse> {
            return localVarFp.saveOtherRoom(otherRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {OfficeRoomRequest} officeRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, officeRoomRequest: OfficeRoomRequest, options?: any): AxiosPromise<RoomResponse> {
            return localVarFp.update(id, officeRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConferenceRoomRequest} conferenceRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1(id: number, conferenceRoomRequest: ConferenceRoomRequest, options?: any): AxiosPromise<RoomResponse> {
            return localVarFp.update1(id, conferenceRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {OtherRoomRequest} otherRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOtherRoom(id: number, otherRoomRequest: OtherRoomRequest, options?: any): AxiosPromise<RoomResponse> {
            return localVarFp.updateOtherRoom(id, otherRoomRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoomControllerApi - object-oriented interface
 * @export
 * @class RoomControllerApi
 * @extends {BaseAPI}
 */
export class RoomControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public deleteRoom(id: number, options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).deleteRoom(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public getAllRooms(options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).getAllRooms(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public getRoomById(id: number, options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).getRoomById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OfficeRoomRequest} officeRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public save(officeRoomRequest: OfficeRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).save(officeRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConferenceRoomRequest} conferenceRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public save1(conferenceRoomRequest: ConferenceRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).save1(conferenceRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtherRoomRequest} otherRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public saveOtherRoom(otherRoomRequest: OtherRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).saveOtherRoom(otherRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {OfficeRoomRequest} officeRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public update(id: number, officeRoomRequest: OfficeRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).update(id, officeRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConferenceRoomRequest} conferenceRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public update1(id: number, conferenceRoomRequest: ConferenceRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).update1(id, conferenceRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {OtherRoomRequest} otherRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomControllerApi
     */
    public updateOtherRoom(id: number, otherRoomRequest: OtherRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomControllerApiFp(this.configuration).updateOtherRoom(id, otherRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatisticsControllerApi - axios parameter creator
 * @export
 */
export const StatisticsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingsStatistic: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/statistics/buildings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesStatistic: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/statistics/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} targetLocalTime 
         * @param {number} buildingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarlyExitsReports: async (startDate: string, endDate: string, targetLocalTime: string, buildingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getEarlyExitsReports', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getEarlyExitsReports', 'endDate', endDate)
            // verify required parameter 'targetLocalTime' is not null or undefined
            assertParamExists('getEarlyExitsReports', 'targetLocalTime', targetLocalTime)
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('getEarlyExitsReports', 'buildingId', buildingId)
            const localVarPath = `/api/statistics/exits-before`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (targetLocalTime !== undefined) {
                localVarQueryParameter['targetLocalTime'] = targetLocalTime;
            }

            if (buildingId !== undefined) {
                localVarQueryParameter['buildingId'] = buildingId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesWithoutTodaysEventsUntilNow: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/statistics/without-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralStatistic: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/statistics/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkstationStatistics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsControllerApi - functional programming interface
 * @export
 */
export const StatisticsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuildingsStatistic(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingStatistic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuildingsStatistic(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getBuildingsStatistic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompaniesStatistic(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyStatistic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompaniesStatistic(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getCompaniesStatistic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} targetLocalTime 
         * @param {number} buildingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEarlyExitsReports(startDate: string, endDate: string, targetLocalTime: string, buildingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeInSpaceEmployeeExitBeforeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEarlyExitsReports(startDate, endDate, targetLocalTime, buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getEarlyExitsReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeesWithoutTodaysEventsUntilNow(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeWithoutEventStatisticsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeesWithoutTodaysEventsUntilNow(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getEmployeesWithoutTodaysEventsUntilNow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralStatistic(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralStatistic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralStatistic(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getGeneralStatistic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkstationStatistics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkstationStatistic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkstationStatistics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getWorkstationStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatisticsControllerApi - factory interface
 * @export
 */
export const StatisticsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingsStatistic(options?: any): AxiosPromise<Array<BuildingStatistic>> {
            return localVarFp.getBuildingsStatistic(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesStatistic(options?: any): AxiosPromise<Array<CompanyStatistic>> {
            return localVarFp.getCompaniesStatistic(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} targetLocalTime 
         * @param {number} buildingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarlyExitsReports(startDate: string, endDate: string, targetLocalTime: string, buildingId: number, options?: any): AxiosPromise<Array<TimeInSpaceEmployeeExitBeforeResponse>> {
            return localVarFp.getEarlyExitsReports(startDate, endDate, targetLocalTime, buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesWithoutTodaysEventsUntilNow(options?: any): AxiosPromise<Array<EmployeeWithoutEventStatisticsResponse>> {
            return localVarFp.getEmployeesWithoutTodaysEventsUntilNow(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralStatistic(options?: any): AxiosPromise<GeneralStatistic> {
            return localVarFp.getGeneralStatistic(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkstationStatistics(options?: any): AxiosPromise<Array<WorkstationStatistic>> {
            return localVarFp.getWorkstationStatistics(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsControllerApi - object-oriented interface
 * @export
 * @class StatisticsControllerApi
 * @extends {BaseAPI}
 */
export class StatisticsControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getBuildingsStatistic(options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getBuildingsStatistic(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getCompaniesStatistic(options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getCompaniesStatistic(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} targetLocalTime 
     * @param {number} buildingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getEarlyExitsReports(startDate: string, endDate: string, targetLocalTime: string, buildingId: number, options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getEarlyExitsReports(startDate, endDate, targetLocalTime, buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getEmployeesWithoutTodaysEventsUntilNow(options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getEmployeesWithoutTodaysEventsUntilNow(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getGeneralStatistic(options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getGeneralStatistic(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getWorkstationStatistics(options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getWorkstationStatistics(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TokensControllerApi - axios parameter creator
 * @export
 */
export const TokensControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AccessControlTokenRequest} accessControlTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard: async (accessControlTokenRequest: AccessControlTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessControlTokenRequest' is not null or undefined
            assertParamExists('createCard', 'accessControlTokenRequest', accessControlTokenRequest)
            const localVarPath = `/api/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessControlTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCard: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCard', 'id', id)
            const localVarPath = `/api/tokens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCard', 'id', id)
            const localVarPath = `/api/tokens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AccessControlTokenUpdateRequest} accessControlTokenUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCard: async (id: number, accessControlTokenUpdateRequest: AccessControlTokenUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCard', 'id', id)
            // verify required parameter 'accessControlTokenUpdateRequest' is not null or undefined
            assertParamExists('updateCard', 'accessControlTokenUpdateRequest', accessControlTokenUpdateRequest)
            const localVarPath = `/api/tokens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessControlTokenUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokensControllerApi - functional programming interface
 * @export
 */
export const TokensControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokensControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AccessControlTokenRequest} accessControlTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCard(accessControlTokenRequest: AccessControlTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessControlTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCard(accessControlTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensControllerApi.createCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCard(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensControllerApi.deleteCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessControlTokenResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensControllerApi.getAllCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCard(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessControlTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensControllerApi.getCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {AccessControlTokenUpdateRequest} accessControlTokenUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCard(id: number, accessControlTokenUpdateRequest: AccessControlTokenUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessControlTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCard(id, accessControlTokenUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensControllerApi.updateCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TokensControllerApi - factory interface
 * @export
 */
export const TokensControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokensControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AccessControlTokenRequest} accessControlTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCard(accessControlTokenRequest: AccessControlTokenRequest, options?: any): AxiosPromise<AccessControlTokenResponse> {
            return localVarFp.createCard(accessControlTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCard(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCards(options?: any): AxiosPromise<Array<AccessControlTokenResponse>> {
            return localVarFp.getAllCards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard(id: number, options?: any): AxiosPromise<AccessControlTokenResponse> {
            return localVarFp.getCard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AccessControlTokenUpdateRequest} accessControlTokenUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCard(id: number, accessControlTokenUpdateRequest: AccessControlTokenUpdateRequest, options?: any): AxiosPromise<AccessControlTokenResponse> {
            return localVarFp.updateCard(id, accessControlTokenUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokensControllerApi - object-oriented interface
 * @export
 * @class TokensControllerApi
 * @extends {BaseAPI}
 */
export class TokensControllerApi extends BaseAPI {
    /**
     * 
     * @param {AccessControlTokenRequest} accessControlTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensControllerApi
     */
    public createCard(accessControlTokenRequest: AccessControlTokenRequest, options?: RawAxiosRequestConfig) {
        return TokensControllerApiFp(this.configuration).createCard(accessControlTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensControllerApi
     */
    public deleteCard(id: number, options?: RawAxiosRequestConfig) {
        return TokensControllerApiFp(this.configuration).deleteCard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensControllerApi
     */
    public getAllCards(options?: RawAxiosRequestConfig) {
        return TokensControllerApiFp(this.configuration).getAllCards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensControllerApi
     */
    public getCard(id: number, options?: RawAxiosRequestConfig) {
        return TokensControllerApiFp(this.configuration).getCard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {AccessControlTokenUpdateRequest} accessControlTokenUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensControllerApi
     */
    public updateCard(id: number, accessControlTokenUpdateRequest: AccessControlTokenUpdateRequest, options?: RawAxiosRequestConfig) {
        return TokensControllerApiFp(this.configuration).updateCard(id, accessControlTokenUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



